export function shouldShowBackToTop(scrollTop, viewportHeight) {
  return scrollTop > viewportHeight * 1.5;
}

export function getBackToTopBehavior(prefersReducedMotion) {
  return prefersReducedMotion ? 'instant' : 'smooth';
}
